import {
    GET_REPORT_TYPES,
    GET_USERS,
    SET_WEEK,
    SET_YEAR,
    SET_USER
} from "./types";
import firebase from "firebase/app";

export const getTimesheets = () => {
    return dispatch => {
        dispatch({ type: GET_REPORT_TYPES.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/reports/`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_REPORT_TYPES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_REPORT_TYPES.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_REPORT_TYPES.FAIL });
        }
    };
};
export const getUsers = () => {
    return dispatch => {
        dispatch({ type: GET_USERS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_USERS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_USERS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_USERS.FAIL });
        }
    };
};
export const setWeek = (week = false) => {
    return dispatch => {
        dispatch({ type: SET_WEEK, payload: week });
    };
};
export const setYear = (year = false) => {
    return dispatch => {
        dispatch({ type: SET_YEAR, payload: year });
    };
};
export const setUser = (user = false) => {
    return dispatch => {
        dispatch({ type: SET_USER, payload: user });
    };
};
